import { Roles } from "../constants";
import { APP_ROUTES } from "../helpers/routeHelpers";
import CustomerManagementIconDark from "../assets/images/app/common/customer-mana-icon-dark.svg";
import FeedbackIconDark from "../assets/images/app/common/feedback-icon-dark.svg";
import NotificationIconDark from "../assets/images/app/common/bell-icon-dark.svg";
import AnalyticsIconDark from "../assets/images/app/common/analytics-icon-dark.svg";

let { Admin, SuperAdmin } = Roles;

const SIDEBAR_CONFIG = [
  {
    title: "BLS Feedback",
    url: APP_ROUTES.BLS_FEEDBACK,
    icon: null,
    menuImg: FeedbackIconDark,
    nestedMenu: null,
    permissions: [Admin],
  },
  {
    title: "Feedback Forms",
    url: APP_ROUTES.FEEDBACK_FORMS,
    icon: null,
    menuImg: FeedbackIconDark,
    nestedMenu: null,
    permissions: [Admin],
  },
  {
    title: "Customer Management",
    url: APP_ROUTES.CUSTOMER_MANAGEMENT,
    icon: null,
    menuImg: CustomerManagementIconDark,
    nestedMenu: null,
    permissions: [Admin],
  },
  {
    title: "Notification Management",
    url: APP_ROUTES.NOTIFICATION_MANAGEMENT,
    icon: null,
    menuImg: NotificationIconDark,
    nestedMenu: null,
    permissions: [Admin],
  },
  {
    title: "Content Library",
    url: APP_ROUTES.CONTENT_LIBRARY,
    icon: null,
    menuImg: NotificationIconDark,
    nestedMenu: null,
    permissions: [Admin],
  },
  {
    title: "Click Analytics",
    url: APP_ROUTES.CLICK_ANALYTICS,
    icon: null,
    menuImg: AnalyticsIconDark,
    nestedMenu: null,
    permissions: [Admin],
  },
  {
    title: "User Analytics",
    url: APP_ROUTES.USER_ANALYTICS,
    icon: null,
    menuImg: AnalyticsIconDark,
    nestedMenu: null,
    permissions: [Admin],
  },
  {
    title: "MCAP Access",
    url: APP_ROUTES.ADMIN_ACCESS,
    icon: null,
    menuImg: AnalyticsIconDark,
    nestedMenu: null,
    permissions: [Admin],
  },
  {
    title: "School Admin Requests",
    url: APP_ROUTES.SCHOOL_ADMIN_REQUESTS,
    icon: null,
    menuImg: CustomerManagementIconDark,
    nestedMenu: null,
    permissions: [Admin],
  },
  {
    title: "District Hub",
    url: APP_ROUTES.DISTRICT_HUB,
    icon: null,
    menuImg: CustomerManagementIconDark,
    nestedMenu: null,
    permissions: [Admin],
  },
  {
    title: "Align Users",
    url: APP_ROUTES.ALIGN_USERS,
    icon: null,
    menuImg: CustomerManagementIconDark,
    nestedMenu: null,
    permissions: [Admin],
  },
  {
    title: "Data Erasure",
    url: APP_ROUTES.DATA_ERASURE,
    icon: null,
    menuImg: CustomerManagementIconDark,
    nestedMenu: null,
    permissions: [Admin],
  },
  {
    title: "Plans & Pricing",
    url: APP_ROUTES.LICENSE_PLANS,
    icon: null,
    menuImg: AnalyticsIconDark,
    nestedMenu: null,
    permissions: [Admin],
  },
  {
    title: "Payments",
    url: APP_ROUTES.LICENSE_PAYMENTS,
    icon: null,
    menuImg: AnalyticsIconDark,
    nestedMenu: null,
    permissions: [Admin],
  },
  {
    title: "Subscription Codes",
    url: APP_ROUTES.REDEMPTION_CODES,
    icon: null,
    menuImg: AnalyticsIconDark,
    nestedMenu: null,
    permissions: [Admin],
  },
  {
    title: "Demo Availability",
    url: APP_ROUTES.DEMO_AVAILABILITY,
    icon: null,
    menuImg: NotificationIconDark,
    nestedMenu: null,
    permissions: [Admin],
  },
];

export default SIDEBAR_CONFIG;
